class CollectionContainer {
  constructor() {
    this.stickyCollectionList = document.querySelector(
      '.js-collection-container',
    );
    this.sentinel = document.querySelector('.js-collection-list-sentinel');
    this.filterAnchor = document.querySelectorAll('.js-filter-anchor');
    this.init();
  }

  init() {
    if (this.filterAnchor.length > 0) {
      this.filterAnchor.forEach((anchor) => {
        anchor.addEventListener('click', (e) => {
          e.preventDefault();
          const targetId = anchor.dataset.hash;
          const targetElement = document.querySelector(targetId);
          if (targetElement) {
            targetElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        });
      });
    }

    if (!this.stickyCollectionList || !this.sentinel) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          this.stickyCollectionList.classList.add('is-sticky');
        } else {
          this.stickyCollectionList.classList.remove('is-sticky');
        }
      },
      {
        root: null,
        threshold: 0,
      },
    );

    observer.observe(this.sentinel);
  }
}

export default CollectionContainer;
